import { ReactNode, useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import { RouteGuard } from "./RouteGuard";

export const ACCOUNT_DEACTIVATED_SESSION_KEY = "account_deactivated_redirect";

interface AccountDeactivatedGuardProps {
  children: ReactNode;
}

/** Soft-deleted SSO identity landing — only after the callback rejected sign-in. */
export const AccountDeactivatedGuard = ({ children }: AccountDeactivatedGuardProps) => {
  const [searchParams] = useSearchParams();

  const allowed = useMemo(() => {
    if (searchParams.get("source") === "sso") {
      return true;
    }
    return sessionStorage.getItem(ACCOUNT_DEACTIVATED_SESSION_KEY) === "1";
  }, [searchParams]);

  useEffect(() => {
    if (allowed) {
      sessionStorage.removeItem(ACCOUNT_DEACTIVATED_SESSION_KEY);
    }
  }, [allowed]);

  return <RouteGuard allowed={allowed}>{children}</RouteGuard>;
};
